export default "__VITE_ASSET__DVs1SNvp__"